<template>
    <ul class="icon-item" :class="{bordered: bordered, hideDisplay: noDisplayMobile}"
        :style="{right: right ? `${right}px` : '-35px'}">
        <li class="icon-link">
            <a href="https://www.facebook.com/revolutionplus.property/" target="_blank" rel="noreferrer noopener" class="social_link">
                <font-awesome-icon :icon="['fab', 'facebook-f']" />
            </a>
        </li>
        <li class="icon-link">
            <a href="https://www.instagram.com/revolutionplusproperty/" target="_blank" rel="noreferrer noopener" class="social_link">
                <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
        </li>
        <li class="icon-link">
            <a href="https://twitter.com/Revolutionplus1" target="_blank" rel="noreferrer noopener" class="social_link">
                <font-awesome-icon :icon="['fab', 'twitter']" />
            </a>
        </li>
        <li class="icon-link">
            <a href="https://www.linkedin.com/company/revolutionplus-property" target="_blank" rel="noreferrer noopener" class="social_link">
                <font-awesome-icon :icon="['fab', 'linkedin-in']" />
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'SocialLinks',
    props: ['bordered', 'right', 'noDisplayMobile']
}
</script>

<style scoped>
.icon-item {
    display: inline-flex;
    flex-direction: column;
    list-style-type: none;
    margin-bottom: 0;
    position: absolute;
    top: 150px;
    right: -35px;
    padding-left: 0;
    border-radius: 20px;
    padding: 5px 0 3px 0;
    border: 1px solid transparent;
    transition: border 0.5s ease-in-out 0s !important;
}
@media (max-width: 992px) {
    .icon-item {
        right: 20px !important
    }
}
@media (max-width: 576px) {
    .hideDisplay {
        display: none
    }
}
@media (min-width: 1200px) {
    .icon-item {
        top: 200px;
    }
}
.icon-item.bordered {
    border: 1px solid #6E2169AA;
}
.icon-item li {
    padding: 10px 5px;
}
.icon-item li a {
    background-color: #6E2169;
    width: 20px;
    height: 20px;
    display: inline-block;
    border-radius: 50%;
}
.icon-item li a svg {
    color: #fff;
    position: relative;
    bottom: 1px;
}
</style>
